import * as React from 'react';
import { addConditionalModifierClass } from '../../../../helpers';

export interface IMemberDetails {
  memberName?: string;
  isMember?: boolean;
}

/**
 * Displays the member state, if a memberName is given
 * @param props 
 * @returns 
 */
export const MemberState = (props: IMemberDetails) => {
  if (!props.memberName) {
    return null;
  }

  const className = addConditionalModifierClass('member-state', 'is-member', props.isMember);

  return (
    <>
      <span className={className}></span>{props.memberName}
    </>
  );
};
